import { CsobFormMetaDataDto, QuestionnaireType } from "@green0meter/api-client";

export const clientFormPlaceholder: CsobFormMetaDataDto = {
  formId: "client-form-placeholder",
  id: "client-form-placeholder",
  name: "Client form",
  questionnaireType: QuestionnaireType.Client,
  createdAtDateTime: "",
  isGroupAsset: false,
  isHedgingAsset: false,
};
